import React from 'react';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import DropZone from '@ts-core/core/components/DropZone';
import Button from '@ts-core/components/Button';
import RichTextEditor from '@ts-core/components/RichTextField';
import { StudentActivity } from '@ts-core/modules/activities/types';

interface DoActivityFormProps {
  sx?: SxProps;

  activity?: StudentActivity;
  loading?: boolean;

  onFileSelected: (file: File) => void;
  file?: File;

  textAnswer?: string;
  onTextAnswerChanged: (text: string) => void;

  onAnswerActivity: () => void;
  answerActivityLoading: boolean;
  answerActivityError?: string;
}

const DoActivityForm = (props: DoActivityFormProps) => {
  const {
    file,
    onFileSelected,
    textAnswer,
    onTextAnswerChanged,
    onAnswerActivity,
    answerActivityLoading,
    answerActivityError,
    activity,
    loading = false,
  } = props;

  if (loading || !activity) {
    return <div />;
  }

  return (
    <Box width="100%">
      <DropZone
        maxSize={activity.answerFileSizeLimit}
        onDropFile={onFileSelected}
        file={file}
        message="Arrastra aquí el archivo que deseas subir o hace click para seleccionar un archivo."
      />
      <RichTextEditor onChange={onTextAnswerChanged} value={textAnswer} />
      {answerActivityError && (
        <Alert severity="error" sx={{ mt: 3 }}>
          {answerActivityError}
        </Alert>
      )}
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button variant="contained" onClick={onAnswerActivity} loading={answerActivityLoading}>
          Entregar tarea
        </Button>
      </Box>
    </Box>
  );
};

export default DoActivityForm;
